// Generated by Avo VERSION 124.82.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true;
        } catch {
          return false;
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self,
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj);
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]',
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value };
      },
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('');
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (
        support.arrayBuffer &&
        (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))
      ) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode);
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse);
    };

    // @ts-ignore
    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read');
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form;
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url,
    });
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } });
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'));
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || ''),
        };
        (options as any).url =
          'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = 'prod',
  Dev = 'dev',
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[];
  shape?: any;
  shapeUserProps?: any;
  actualType?: string;
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = 'CbPmaYMPq17SVhvzCYMB';
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;

// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target: any, _varArgs: any) {
      // .length of function is 2
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true,
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = 'BottomRight',
  BottomLeft = 'BottomLeft',
  TopRight = 'TopRight',
  TopLeft = 'TopLeft',
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
};

let InternalAvoLogger: any = {
  logEventSent: function logEventSent(
    eventName: string,
    eventProperties: any,
    userProperties: any,
  ) {
    const message =
      'Event Sent:' +
      eventName +
      'Event Props:' +
      JSON.stringify(eventProperties) +
      'User Props:' +
      JSON.stringify(userProperties);

    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logDebug &&
      __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
    ) {
      return;
    }
    typeof console !== 'undefined' &&
      console.log(
        '[avo] Event Sent:',
        eventName,
        'Event Props:',
        eventProperties,
        'User Props:',
        userProperties,
      );
  },

  log: function log(message: string) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logDebug &&
      __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
    ) {
      return;
    }
    typeof console !== 'undefined' && console.log('[avo] ' + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return;
    }
    typeof console !== 'undefined' && console.warn('[avo] ' + message);
  },

  error: function error(message: string, error: string) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logError &&
      __AVO_LOGGER__.logError(__AVO_ENV__, message + error)
    ) {
      return;
    }
    typeof console !== 'undefined' && console.error('[avo] ' + message, error);
  },
};

function convertPropertiesArrayToMap(
  propertiesArray: [{ id: string; name: string; value: string }],
): { string: string | null | undefined } {
  let result: { string: string } = {};

  propertiesArray.forEach((value) => {
    result[value.name] = value.value;
  });

  return result;
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
};

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message =
        propName +
        ' should be of type object but you provided type ' +
        typeof obj +
        ' with value ' +
        JSON.stringify(obj);
      return [{ tag: 'expectedObjectType', propertyId, message, actualType: typeof obj }];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message =
        propName +
        ' should be of type string but you provided type ' +
        typeof str +
        ' with value ' +
        JSON.stringify(str);
      return [{ tag: 'expectedStringType', propertyId, message, actualType: typeof str }];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message =
        propName +
        ' should be of type int but you provided type float with value ' +
        JSON.stringify(int);
      return [{ tag: 'expectedIntType', propertyId, message, actualType: 'float' }];
    } else if (typeof int !== 'number') {
      let message =
        propName +
        ' should be of type int but you provided type ' +
        typeof int +
        ' with value ' +
        JSON.stringify(int);
      return [{ tag: 'expectedIntType', propertyId, message, actualType: typeof int }];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message =
        propName +
        ' should be of type long but you provided type float with value ' +
        JSON.stringify(long);
      return [{ tag: 'expectedLongType', propertyId, message, actualType: 'float' }];
    } else if (typeof long !== 'number') {
      let message =
        propName +
        ' should be of type long but you provided type ' +
        typeof long +
        ' with value ' +
        JSON.stringify(long);
      return [{ tag: 'expectedLongType', propertyId, message, actualType: typeof long }];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message =
        propName +
        ' should be of type float but you provided type ' +
        typeof float +
        ' with value ' +
        JSON.stringify(float);
      return [{ tag: 'expectedFloatType', propertyId, message, actualType: typeof float }];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message =
        propName +
        ' should be of type boolean but you provided type ' +
        typeof bool +
        ' with value ' +
        JSON.stringify(bool);
      return [{ tag: 'expectedBoolType', propertyId, message, actualType: typeof bool }];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(propertyId: string, propName: string, max: number, value: number) {
    if (value > max) {
      let message =
        propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{ tag: 'expectedMax', propertyId, message }];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(propertyId: string, propName: string, min: number, value: number) {
    if (value < min) {
      let message =
        propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{ tag: 'expectedMin', propertyId, message }];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{ tag: 'expectedList', propertyId, message }];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message =
        'Additional properties when sending event ' +
        eventName +
        ': ' +
        JSON.stringify(additionalKeys);
      return [
        {
          tag: 'expectedNoAdditionalProperties',
          additionalProperties: additionalKeys,
          message: message,
        },
      ];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message =
        'Additional user properties when sending event ' +
        eventName +
        ': ' +
        JSON.stringify(additionalKeys);
      return [
        {
          tag: 'expectedNoAdditionalUserProperties',
          additionalProperties: additionalKeys,
          message: message,
        },
      ];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(
  env: AvoEnv,
  eventId: string,
  hash: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 'TbC3sPWW2EjQP72FuQ8U',
          br: 'master',
          en: env,
          ev: eventId,
          ha: hash,
          sc: 'Qxw4SpNZAmmYOzZQPcag',
          se: new Date().toISOString(),
          so: 'xvYfJy7q_',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json();
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function () {});
    }
  }
};

_avo_invoke_meta = function _avo_invoke_meta(
  env: AvoEnv,
  type: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 'TbC3sPWW2EjQP72FuQ8U',
          br: 'master',
          en: env,
          ty: type,
          sc: 'Qxw4SpNZAmmYOzZQPcag',
          se: new Date().toISOString(),
          so: 'xvYfJy7q_',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json();
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function () {});
    }
  }
};

let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    let iframe: any = document.getElementById('avo-debugger');
    if (iframe && event && event.data && event.data.type_ === 'avo-debugger-update-style') {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === 'avo-debugger-ready') {
      let message = {
        type_: 'avo-debugger-boot-events',
        schemaId: 'Qxw4SpNZAmmYOzZQPcag',
        href: window.location.href,
        events: _avo_debugger_events_during_boot,
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(
  eventId: string,
  eventName: string,
  messages: any[],
  eventProperties: any[],
  userProperties: any[],
  groupProperties: any[],
) {
  if (typeof (window as any) === 'undefined') {
    return;
  }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties,
  };

  if (_avo_debugger_ready) {
    let message = { type_: 'avo-debugger-events', events: [event] };
    (document.getElementById('avo-debugger') as any).contentWindow.postMessage(
      message,
      'https://www.avo.app/_debugger',
    );
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
};

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') {
    return;
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    if (event.data.type_ === 'avo-debugger-ready' && position !== null) {
      var message = { type_: 'avo-debugger-position', position: position };
      document
        .getElementById('avo-debugger')
        .contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
    }
  });
}

export const View = {
  CURRENT_TASK: 'current_task',
  NEW_TASK: 'new_task',
  PURCHASES: 'purchases',
  BUSINESS_INSIGHTS: 'business_insights',
  MENU_EDITOR: 'menu_editor',
  LOGIN_PAGE: 'login_page',
  ONBOARDING_LANDING_PAGE: 'onboarding_landing_page',
  ONBOARDING_REGISTRATION_PAGE: 'onboarding_registration_page',
  FRICTION_TO_REJECT: 'friction_to_reject',
  SUPPORT_LAYER: 'support_layer',
  SUPPORT_INBOX_TICKET: 'support_inbox_ticket',
  SUPPORT_INBOX: 'support_inbox',
  FEATURED: 'featured',
  CHECKOUT: 'checkout',
  CHAT: 'chat',
  NEW_CHAT_MESSAGE: 'new_chat_message',
  VENUE: 'venue',
  ONBOARDING_CHOOSE_CONTRACT: 'onboarding_choose_contract',
  ONBOARDING_CHOOSE_COUNTRY: 'onboarding_choose_country',
  ONBOARDING_SELECT_CONTRACT: 'onboarding_select_contract',
  ONBOARDING_SELECT_DOCUMENT: 'onboarding_select_document',
  ONBOARDING_UPLOAD_DOCUMENT: 'onboarding_upload_document',
  ONBOARDING_CONTINUE_VERIFICATION: 'onboarding_continue_verification',
  ONBOARDING_DOCUMENT_VERIFICATION_CITIZENSHIP: 'onboarding_document_verification_citizenship',
  ONBOARDING_IDENTITY_VERIFICATION: 'onboarding_identity_verification',
  ONBOARDING_WAITING_FOR_CONTRACT: 'onboarding_waiting_for_contract',
  ONBOARDING_VERIFICATION_ERROR: 'onboarding_verification_error',
  ONBOARDING_VERIFICATION_STATUS: 'onboarding_verification_status',
  ONBOARDING_OVERVIEW: 'onboarding_overview',
  ONBOARDING_CONTINUE_TO_CONTRACT: 'onboarding_continue_to_contract',
  ENTERPRISE_ANALYTICS: 'enterprise_analytics',
  PERFORMANCE_INSIGHTS: 'performance_insights',
  REASONS_FOR_REJECTION: 'reasons_for_rejection',
  HOMEPAGE: 'homepage',
  SUPPORT_INBOX_CONVERSATION: 'support_inbox_conversation',
  IMPORTANT_UPDATES: 'important_updates',
  ALL_ITEMS: 'all_items',
  ALL_OPTIONS: 'all_options',
  ALL_DISABLED: 'all_disabled',
  ITEMS_NO_CATEGORY: 'items_no_category',
  CATEGORIES: 'categories',
  CAMPAIGNS: 'campaigns',
  CHOOSE_CAMPAIGN: 'choose_campaign',
  NEW_CAMPAIGN: 'new_campaign',
  NEW_CAMPAIGN_RULES: 'new_campaign_rules',
  UPDATE_CAMPAIGN: 'update_campaign',
  ONBOARDING_REGISTRATION_DETAILS: 'onboarding_registration_details',
  ONBOARDING_APPLICATION: 'onboarding_application',
  ONBOARDING_DELIVERY_PREFERENCES: 'onboarding_delivery_preferences',
  ONBOARDING_SMS_VERIFICATION: 'onboarding_sms_verification',
  ONBOARDING_GET_GEAR: 'onboarding_get_gear',
  ONBOARDING_FINAL_SCREEN: 'onboarding_final_screen',
  BUSINESS_INSIGHTS_V2: 'business_insights_v2',
  ENTERPRISE_USER_MANAGEMENT: 'enterprise_user_management',
  CART: 'cart',
  VENUE_ITEM: 'venue_item',
  APP_REFERRAL_BANNER: 'app_referral_banner',
  APP_REFERRAL_LINK: 'app_referral_link',
  CAMPAIGN_DETAILS: 'campaign_details',
  BRAND_EDITOR: 'brand_editor',
  CUTLERY_ITEM: 'cutlery_item',
  CATALOG_LIST: 'catalog_list',
  LOYALTY_PROGRAM: 'loyalty_program',
  ADD_LOYALTY_CARD: 'add_loyalty_card',
  LOYALTY_CARD_DETAILS: 'loyalty_card_details',
  MENU_CATEGORY: 'menu_category',
  SEARCH: 'search',
  RESTAURANTS: 'restaurants',
  LIVE_PURCHASES: 'live_purchases',
  RESTAURANT_DETAILS: 'restaurant_details',
  STARTUP: 'startup',
  PAGE_DELIVERY_VENUES: 'page_delivery_venues',
  VENUE_SEARCH: 'venue_search',
  ADD_NEW_ADDRESS: 'add_new_address',
  CREDITS_AND_TOKENS: 'credits_and_tokens',
  ADD_CARD: 'add_card',
  ADD_LOYALTY_NUMBER: 'add_loyalty_number',
  ADDRESS_TYPE: 'address_type',
  ADDRESSES: 'addresses',
  AGE_RESTRICTION_NOTIFICATION: 'age_restriction_notification',
  AGE_VERIFICATION: 'age_verification',
  CANCEL: 'cancel',
  CAROUSEL_ITEM_LIST_SEARCH: 'carousel_item_list_search',
  CODE_NOT_RECEIVED: 'code_not_received',
  COMMENT_FOR_VENUE: 'comment_for_venue',
  CONFIRM_CARD: 'confirm_card',
  COURIERAPPLICATION_APPLICATION_STATUS: 'courierapplication_application_status',
  COURIERAPPLICATION_APPLYNOW: 'courierapplication_applyNow',
  COURIERAPPLICATION_DELIVERY_DETAILS: 'courierapplication_delivery_details',
  COURIERAPPLICATION_DONE: 'courierapplication_done',
  COURIERAPPLICATION_FRONT: 'courierapplication_front',
  COURIERAPPLICATION_PROFILE_DETAILS: 'courierapplication_profile_details',
  CREATE_GROUP: 'create_group',
  CREDITS_AND_TOKENS_DETAILS: 'credits_and_tokens_details',
  DELETE_ACCOUNT: 'delete_account',
  DELETE_ACCOUNT_REQUESTED: 'delete_account_requested',
  DISCOVERY_OOR_MAP: 'discovery_oor_map',
  EARN_FREE_DELIVERIES: 'earn_free_deliveries',
  EASTER_EGG_V1: 'easter_egg_v1',
  EDIT_CARD: 'edit_card',
  EMAIL: 'email',
  EMAIL_CODE: 'email_code',
  EMAIL_CODE_NOT_RECEIVED: 'email_code_not_received',
  EMAIL_LOGIN_PROGRESS: 'email_login_progress',
  EMAIL_NOT_RECEIVED: 'email_not_received',
  ENTER_EMAIL: 'enter_email',
  ENTER_PHONE_NUMBER: 'enter_phone_number',
  ENTER_VERIFICATION_CODE: 'enter_verification_code',
  ENTRANCE_LOCATION: 'entrance_location',
  ERROR: 'error',
  EXTRA_CONSENTS: 'extra_consents',
  FILTERS: 'filters',
  FRONT_PAGE: 'front_page',
  GROUP_INTRO: 'group_intro',
  GROUP_LOBBY: 'group_lobby',
  GROUP_LOGIN_OPTIONS: 'group_login_options',
  GROUP_ORDER_LOGIN: 'group_order_login',
  GROUP_ORDER_PAYMENT_DETAILS: 'group_order_payment_details',
  GUEST_CONSENTS: 'guest_consents',
  HUNGARY_GROCERY_NOTICE: 'hungary_grocery_notice',
  IMAGE_ZOOM: 'image_zoom',
  INPUT_CODE: 'input_code',
  INTERSTITIAL_ITEM: 'interstitial_item',
  INTRO: 'intro',
  INVITE_FRIENDS: 'invite_friends',
  INVITE_FRIENDS_DETAILS: 'invite_friends_details',
  INVITE_GROUP_MEMBERS: 'invite_group_members',
  JOIN_GROUP: 'join_group',
  LINKING_ACCOUNT: 'linking_account',
  LINKING_ACCOUNT_PROGRESS: 'linking_account_progress',
  LOGIN: 'login',
  LOYALTY_WALLET: 'loyalty_wallet',
  LOYALTY_WALLET_NEW_CARD: 'loyalty_wallet_new_card',
  MAP: 'map',
  MOBILE_NUMBER: 'mobile_number',
  MOBILE_NUMBER_CODE: 'mobile_number_code',
  MOBILE_NUMBER_CODE_NOT_RECEIVED: 'mobile_number_code_not_received',
  NEW_VERSION_DIALOG: 'new-version-dialog',
  NEW_ADDRESS: 'new_address',
  NO_LOCATION: 'no_location',
  ORDER_HISTORY: 'order_history',
  ORDER_TYPE: 'order_type',
  PAGE_CURATED_CONTENT: 'page_curated_content',
  PAYMENT_METHOD_PICKER: 'payment_method_picker',
  PAYMENT_METHODS: 'payment_methods',
  PERSONAL_INFO: 'personal_info',
  POSTCODE_ADDRESS_SEARCH_STEP1_POSTCODE: 'postcode_address_search_step1_postcode',
  POSTCODE_ADDRESS_SEARCH_STEP2_ADDRESS: 'postcode_address_search_step2_address',
  POSTCODE_ADDRESS_SEARCH_STEP3_MAP: 'postcode_address_search_step3_map',
  PRISMIC_PAGE: 'prismic_page',
  PROFILE_ACCOUNT: 'profile_account',
  PROFILE_ACCOUNT_NAME: 'profile_account_name',
  PROMO_CODE_APPLIED: 'promo_code_applied',
  PURCHASE_SESSION_SUBSCRIPTION: 'purchase_session_subscription',
  PURCHASE_SESSION_TIP_ORDER_REVIEW: 'purchase_session_tip_order_review',
  PUSH_PERMISSION_GENERAL: 'push_permission_general',
  PUSH_PERMISSION_ORDER: 'push_permission_order',
  REDEEM_CODE: 'redeem_code',
  REFERRAL_AFTER_PURCHASE: 'referral_after_purchase',
  REFILL: 'refill',
  REQUEST_EMAIL_PROGRESS: 'request_email_progress',
  REQUEST_EMAIL_SUCCESS: 'request_email_success',
  REQUEST_VAT_RECEIPT: 'request_vat_receipt',
  SEARCH_LOCATION: 'search_location',
  SEARCH_SUGGESTIONS: 'search_suggestions',
  SEND_ORDER: 'send_order',
  SETTINGS: 'settings',
  SIGN_UP_FORM: 'sign_up_form',
  SIGN_UP_PROGRESS: 'sign_up_progress',
  SIGNUP_VERIFY_SMS_CODE: 'signup_verify_sms_code',
  SMS_CODE_PROGRESS: 'sms_code_progress',
  SOCIAL_LOGIN_PROGRESS: 'social_login_progress',
  SUBSCRIPTION_CANCEL: 'subscription_cancel',
  SUBSCRIPTION_CANCEL_SURVEY: 'subscription_cancel_survey',
  SUBSCRIPTION_CHANGE_PAYMENT_METHOD: 'subscription_change_payment_method',
  SUBSCRIPTION_MANAGE: 'subscription_manage',
  SUBSCRIPTION_MANAGE_DETAILS: 'subscription_manage_details',
  SUBSCRIPTION_PAYMENT_CYCLE_PICKER: 'subscription_payment_cycle_picker',
  SUBSCRIPTION_PAYMENTS_HISTORY: 'subscription_payments_history',
  SUBSCRIPTION_PAYMENTS_HISTORY_DETAILS: 'subscription_payments_history_details',
  SUBSCRIPTION_PURCHASE: 'subscription_purchase',
  SUBSCRIPTION_PURCHASE_CONFIRM: 'subscription_purchase_confirm',
  SUBSTITUTIONS: 'substitutions',
  SUGGESTED_ADDRESS: 'suggested_address',
  UNKNOWN: 'unknown',
  VENUE_INFO: 'venue_info',
  WAW_INVALID_INVITATION_POPUP: 'waw_invalid_invitation_popup',
  WAW_USER_POPUP: 'waw_user_popup',
  WAW_VISITOR_POPUP: 'waw_visitor_popup',
  WOLT_AT_WORK_ADVERTISE_BANNER: 'wolt-at-work-advertise-banner',
  WOLT_AT_WORK_CONTACT_FORM: 'wolt-at-work-contact-form',
  WOLT_AT_WORK_SELF_SIGNUP_FORM: 'wolt-at-work-self-signup-form',
  WOLT_AT_WORK_TAB: 'wolt_at_work_tab',
  YOUR_ORDER_TRACKING: 'your_order_tracking',
  HOME: 'home',
  RATING: 'rating',
  ORDER_HISTORY_DETAILS: 'order_history_details',
  VENUE_AVAILABILITY: 'venue_availability',
  ADDRESS_FORM: 'address_form',
  PURCHASE_SESSION_CHECKOUT: 'purchase_session_checkout',
  MENU_CATEGORY_SEARCH: 'menu_category_search',
  CAROUSEL_ITEM_LIST: 'carousel_item_list',
  RETAIL: 'retail',
  ORDER_TRACKING: 'order_tracking',
  EASTER_EGG_V2: 'easter_egg_v2',
  EMAIL_LOGIN_CONFIRMATION: 'email_login_confirmation',
  PROFILE: 'profile',
  CART_ESTIMATED_WOLT_POINTS_DIALOG: 'cart_estimated_wolt_points_dialog',
  WOLT_REWARDS: 'wolt_rewards',
  WOLT_REWARDS_POINT_HISTORY: 'wolt_rewards_point_history',
  WOLT_REWARDS_POINT_HISTORY_REWARD: 'wolt_rewards_point_history_reward',
  WOLT_REWARD_CLAIMED: 'wolt_reward_claimed',
  WOLT_REWARD_PROGRESSION: 'wolt_reward_progression',
  USE_WOLT_POINTS: 'use_wolt_points',
  WOLT_REWARDS_INTRO: 'wolt_rewards_intro',
  ORDER_BUBBLE: 'order_bubble',
  WOLT_REWARDS_INTRO_INFO: 'wolt_rewards_intro_info',
  ESTIMATED_WOLT_POINTS: 'estimated_wolt_points',
  AGE_VERIFICATION_ERROR: 'age_verification_error',
  CLEAR_AGE_DATA: 'clear_age_data',
  LOYALTY_WOLT_POINT_CLAIM_INCENTIVE: 'loyalty_wolt_point_claim_incentive',
  BUSINESS_INSIGHTS_V2_MENU: 'business_insights_v2_menu',
  BUSINESS_INSIGHTS_V2_OPERATIONS: 'business_insights_v2_operations',
  BUSINESS_INSIGHTS_V2_PERFORMANCE: 'business_insights_v2_performance',
  BUSINESS_INSIGHTS_V2_CUSTOMER_BASE: 'business_insights_v2_customer_base',
  SHARED_MENU: 'shared_menu',
  APPLICATION_SENT: 'application_sent',
  PRODUCT_BRANDS: 'product_brands',
  DOWNLOAD_APP: 'download_app',
  POST_ORDER_TIPPING: 'post_order_tipping',
  HISTORICAL_AVAILABILITY: 'historical_availability',
  GOOGLE_SHEET_PAGE: 'google_sheet_page',
  DELIVERY_TYPE_MODAL: 'delivery_type_modal',
  BUSINESS_INSIGHTS_V2_RATINGS_REVIEWS: 'business_insights_v2_ratings_reviews',
  VENUE_AREA: 'venue_area',
  ORDERS: 'orders',
  MEMBERS: 'members',
  INVOICES: 'invoices',
  DELIVERIES: 'deliveries',
  GROUPS: 'groups',
  POLICIES: 'policies',
  EVENTS: 'events',
  COMPANY_SETTINGS: 'company_settings',
  VENUE_GROUP: 'venue_group',
  ADJUSTMENT_ITEM_RESERVATION_MODAL: 'adjustment_item_reservation_modal',
  FEEDBACK: 'feedback',
  MERCHANT_ADMIN_USER_SETTINGS: 'merchant_admin_user_settings',
  MERCHANT_ADMIN_SEARCH: 'merchant_admin_search',
  REPORT_INAPPROPRIATE_BEHAVIOUR: 'report_inappropriate_behaviour',
  CHECK_EMAIL_LOGIN: 'check_email_login',
  MAGIC_LINK_VERIFICATION: 'magic_link_verification',
  EMAIL_LOGIN: 'email_login',
  LOGIN_OR_APPLY: 'login_or_apply',
  SUBSCRIPTION_PURCHASE_OUTCOME: 'subscription_purchase_outcome',
  SUBSCRIPTION_PURCHASE_WELCOME: 'subscription_purchase_welcome',
  ONBOARDING_APPLICATION_SENT: 'onboarding_application_sent',
  ONBOARDING_DOWNLOAD_APP: 'onboarding_download_app',
  MERCHANT_SELF_SERVICE_SIGN_UP: 'merchant_self_service_sign_up',
  VENUE_LIST: 'venue_list',
  BANNER_LIST: 'banner_list',
  SEARCH_MENU_ITEM_LIST: 'search_menu_item_list',
  PROMO_CONSENTS: 'promo_consents',
  PUSH_NOTIFICATION: 'push_notification',
  GEOLOCATION_HISTORY: 'geolocation_history',
  ADD_TO_INVENTORY: 'add_to_inventory',
  RECEIVING: 'receiving',
  SEARCH_RECEIVING: 'search_receiving',
  RECENTLY_ADDED_ITEMS: 'recently_added_items',
  EDIT_RECEIVING_EVENT: 'edit_receiving_event',
  MULTIPLE_POS: 'multiple_pos',
  BARCODE_SCAN: 'barcode_scan',
  SUBSCRIPTION_PURCHASE_EXPRESS: 'subscription_purchase_express',
} as const;
export type ViewType = typeof View;
export type ViewValueType = ViewType[keyof ViewType];

export const ClickTarget = {
  CLOSE: 'close',
  EDIT_ITEM: 'edit_item',
  CANCEL: 'cancel',
  BACK: 'back',
  SAVE: 'save',
  ADJUST_LATER: 'adjust_later',
  ADJUST_INVENTORY: 'adjust_inventory',
  SUBMIT: 'submit',
  RATING: 'rating',
  COMMENT: 'comment',
  APPLY: 'apply',
  ADD_BATCH: 'add_batch',
  REMOVE_BATCH: 'remove_batch',
  SEARCH_RESULTS: 'search_results',
  BARCODE_SCAN_RESULTS: 'barcode_scan_results',
  PURCHASE_ORDERS: 'purchase_orders',
  RECENTLY_ADDED_ITEMS: 'recently_added_items',
  USER_GUIDES: 'user_guides',
  PRODUCT_IMAGE: 'product_image',
  ADD_ANOTHER_BATCH: 'add_another_batch',
  ADD_TO_INVENTORY: 'add_to_inventory',
  SHOW_MORE_INFO: 'show_more_info',
  SHOW_SHIPMENT_INFO: 'show_shipment_info',
  EXPIRATION_DATE: 'expiration_date',
  UNIT_QUANTITY: 'unit_quantity',
  ADD_TO_LOCATION: 'add_to_location',
  MULTIPLE_POS: 'multiple_pos',
  INCREASE_QUANTITY: 'increase_quantity',
  DECREASE_QUANTITY: 'decrease_quantity',
  SHOW_CHANGE_LOG: 'show_change_log',
} as const;
export type ClickTargetType = typeof ClickTarget;
export type ClickTargetValueType = ClickTargetType[keyof ClickTargetType];

export const LogType = {
  VIEW: 'view',
  DATA: 'data',
  INTERACTION: 'interaction',
  ERROR: 'error',
} as const;
export type LogTypeType = typeof LogType;
export type LogTypeValueType = LogTypeType[keyof LogTypeType];

export const EventName = {
  'BUSINESS_INSIGHTS_VIEW': 'business_insights_view',
  'CONTACT_SUPPORT': 'contact_support',
  'HOMEPAGE_VIEW': 'homepage_view',
  'MENU_EDITOR_VIEW': 'menu_editor_view',
  'PURCHASES_VIEW': 'purchases_view',
  'CLICK': 'click',
  'DISAPPEARED': 'disappeared',
  'ONBOARDING_REGISTRATION_PAGE_VIEW': 'onboarding_registration_page_view',
  'ONBOARDING_LANDING_PAGE_INTERACTION_GET_STARTED':
    'onboarding_landing_page_interaction_get_started',
  'ONBOARDING_LANDING_PAGE_VIEW': 'onboarding_landing_page_view',
  'ONBOARDING_REGISTRATION_PAGE_INTERACTION_APPLY':
    'onboarding_registration_page_interaction_apply',
  'ONBOARDING_REGISTRATION_PAGE_INTERACTION_LOGIN':
    'onboarding_registration_page_interaction_login',
  'SELECTOR': 'selector',
  'CONTENT_CHANGED': 'content_changed',
  'NO_LOCATION': 'no_location',
  'BANNER': 'banner',
  'MENU_ITEM': 'menu_item',
  'VENUE': 'venue',
  'SUPPORT_INBOX_VIEW': 'support_inbox_view',
  'CONFIRM_ORDER': 'confirm_order',
  'COURIER_INSTRUCTIONS': 'courier_instructions',
  'ORDER_FAILED': 'order_failed',
  'SELECT_CONFIRMATION_PICKUP_NO': 'select_confirmation_pickup_no',
  'SEND_ORDER': 'send_order',
  'SWIPE': 'swipe',
  'MENU_CATEGORY': 'menu_category',
  'FILLED': 'filled',
  'LOAD_LOOKER_DASHBOARD': 'load_looker_dashboard',
  'CSV_DOWNLOAD': 'csv_download',
  'DATA_CHART_HOVER': 'data_chart_hover',
  'NEW_CAMPAIGN_CREATED': 'new_campaign_created',
  'CAMPAIGN_RULES': 'campaign_rules',
  'END_CAMPAIGN': 'end_campaign',
  'UPDATE_CAMPAIGN': 'update_campaign',
  'BUSINESS_INSIGHTS_V2_VIEW': 'business_insights_v2_view',
  'INTRODUCTION_LINK': 'introduction_link',
  'CONTRACT_LINK': 'contract_link',
  'INTRODUCTION_LINK_ERROR': 'introduction_link_error',
  'UPFRONT_PRICE': 'upfront_price',
  'DISTANCE': 'distance',
  'PRICE_BOOST': 'price_boost',
  'CART_ITEMS': 'cart_items',
  'ADD_TO_ORDER': 'add_to_order',
  'ADD_OPTIONS': 'add_options',
  'REMOVE_OPTIONS': 'remove_options',
  'OPEN_APP_LINK': 'open_app_link',
  'CHOOSE_CAMPAIGN_VIEW': 'choose_campaign_view',
  'NEW_CAMPAIGN_VIEW': 'new_campaign_view',
  'UPDATE_CAMPAIGN_VIEW': 'update_campaign_view',
  'CAMPAIGN_DETAILS_VIEW': 'campaign_details_view',
  'BRAND': 'brand',
  'CUTLERY_ITEM': 'cutlery_item',
  'ADD_CUTLERY_TO_ORDER': 'add_cutlery_to_order',
  'REMOVE_CUTLERY_FROM_ORDER': 'remove_cutlery_from_order',
  'OPEN_LOYALTY_BANNER': 'open_loyalty_banner',
  'OPEN_LOYALTY_CARD_DETAILS': 'open_loyalty_card_details',
  'LOYALTY_NUMBER_STATUS': 'loyalty_number_status',
  'CATEGORY_SHOWN': 'category_shown',
  'SUBCATEGORY_SHOWN': 'subcategory_shown',
  'RESULTS': 'results',
  'PAGES_FRONT': 'pages_front',
  'STARTUP_TIME': 'startup_time',
  'COUNTRY_CHANGED': 'country_changed',
  'CREDITS_BALANCE': 'credits_balance',
  '3DS_EXIT': '3ds_exit',
  '3DS_START': '3ds_start',
  'ACCOUNTS_JOINED': 'accounts_joined',
  'ADD_CARD_COMPLETED': 'add_card_completed',
  'ADD_COMPANY_DETAILS': 'add_company_details',
  'ADDRESS_GEOCODE_RESULT': 'address_geocode_result',
  'ADJUSTING_PIN_DURATION': 'adjusting_pin_duration',
  'CHANGE_EMAIL_SUCCESS': 'change_email_success',
  'CHANGE_MOBILE_NUMBER_SUCCESS': 'change_mobile_number_success',
  'CLIENT_PAYMENT_AUTH_EXIT': 'client_payment_auth_exit',
  'CLIENT_PAYMENT_AUTH_START': 'client_payment_auth_start',
  'CLIENT_TIMEOUT': 'client_timeout',
  'COMMENT_LEFT': 'comment_left',
  'COMPANY_PAYING_SLIDER': 'company_paying_slider',
  'CONFIRM_CARD_COMPLETED': 'confirm_card_completed',
  'CONSENTS': 'consents',
  'CONTACT_FORM_SENT_SUCCESS': 'contact_form_sent_success',
  'CREATE_GROUP': 'create_group',
  'CREATE_PURCHASE_ERROR': 'create_purchase_error',
  'DATA': 'data',
  'DELETE_ACCOUNT': 'delete_account',
  'EDIT_CARD_COMPLETED': 'edit_card_completed',
  'ERROR_ACTIVE_ORDER': 'error_active_order',
  'ERROR_EMAIL_IN_USE': 'error_email_in_use',
  'ERROR_INCORRECT_MOBILE_NUMBER': 'error_incorrect_mobile_number',
  'ERROR_MOBILE_NUMBER_IN_USE': 'error_mobile_number_in_use',
  'ERROR_TOO_MANY_CHANGES': 'error_too_many_changes',
  'GET_STARTED': 'get_started',
  'GET_STARTED_INFO': 'get_started_info',
  'GOTO_CONTACT_FORM': 'goto_contact_form',
  'INCORRECT_CODE': 'incorrect_code',
  'INVITE_DONE': 'invite_done',
  'ITEM': 'item',
  'JOIN_GROUP': 'join_group',
  'KEYBOARD_ENTER': 'keyboard_enter',
  'LOGIN_COMPLETED': 'login_completed',
  'LOGIN_RESULT': 'login_result',
  'MISSING_ITEMS_APPLIED': 'missing_items_applied',
  'MODAL_CONTINUE_WITHOUT_SAVING': 'modal_continue_without_saving',
  'PHONE_NUMBER_VERIFICATION_COMPLETED': 'phone_number_verification_completed',
  'POPUP': 'popup',
  'POSTCODE_RESULT': 'postcode_result',
  'PRE_PURCHASE_ACTION': 'pre_purchase_action',
  'PROMO_CODE_INSERTED': 'promo_code_inserted',
  'PURCHASE_START': 'purchase_start',
  'RESULT': 'result',
  'SAVING_FAILED': 'saving_failed',
  'SELECT_SIGNUP_ACCOUNT': 'select_signup_account',
  'SELECTIONS_APPLIED': 'selections_applied',
  'SIGN_UP_RESULT': 'sign_up_result',
  'SIGNUP_COMPLETED': 'signup_completed',
  'SUBSCRIPTION_RESULT': 'subscription_result',
  'TIP_STATUS_UPDATE': 'tip_status_update',
  'SIGNUP': 'signup',
  'LOGIN': 'login',
  'PURCHASE_RATING': 'purchase_rating',
  'ADDRESS_ADDED': 'address_added',
  'APARTMENT_TYPE_CHANGED': 'apartment_type_changed',
  'OPTIONAL_FIELD': 'optional_field',
  'STREET_ADDRESS_CHANGED': 'street_address_changed',
  'ORDER_STATUS_UPDATE': 'order_status_update',
  'PURCHASE_SESSION_SUBSCRIPTION': 'purchase_session_subscription',
  'CONFIRM': 'confirm',
  'LEARN_MORE': 'learn_more',
  'UPDATE_ITEM_SUBSTITUTION_COMMENT': 'update_item_substitution_comment',
  'BUSINESS_INSIGHTS_V2_PERFORMANCE_VIEW': 'business_insights_v2_performance_view',
  'BUSINESS_INSIGHTS_V2_OPERATIONS_VIEW': 'business_insights_v2_operations_view',
  'BUSINESS_INSIGHTS_V2_CUSTOMER_BASE_VIEW': 'business_insights_v2_customer_base_view',
  'BUSINESS_INSIGHTS_V2_MENU_VIEW': 'business_insights_v2_menu_view',
  'BOTTOM_REACHED': 'bottom_reached',
  'ESTIMATED_WOLT_POINTS': 'estimated_wolt_points',
  'USE_WOLT_POINTS': 'use_wolt_points',
  'DISMISS': 'dismiss',
  'CLAIM_REWARD': 'claim_reward',
  'TO_POINT_HISTORY': 'to_point_history',
  'EARNED_WOLT_POINTS': 'earned_wolt_points',
  'LOADING_ERROR': 'loading_error',
  'TOAST': 'toast',
  'OPEN_PROFILE_ACCOUNT': 'open_profile_account',
  'OPEN_WOLT_REWARDS': 'open_wolt_rewards',
  'WOLT_REWARD_PROGRESSION': 'wolt_reward_progression',
  'CLOSE': 'close',
  'OPEN_ORDER_TRACKING': 'open_order_tracking',
  'SCROLL': 'scroll',
  'USE_ALL_WOLT_POINTS': 'use_all_wolt_points',
  'LEVEL_CARD': 'level_card',
  'UPDATE_CART_ITEMS': 'update_cart_items',
  'APPLE_PAY_ON_DEVICE': 'apple_pay_on_device',
  'SELECT_CONFIRMATION_EATIN_NO': 'select_confirmation_eatin_no',
  'TO_WOLT_REWARDS': 'to_wolt_rewards',
  'UPDATE_TIP': 'update_tip',
  'LOAD_LOOKER_DASHBOARD_ERROR': 'load_looker_dashboard_error',
  'IMAGE_VIEWED': 'image_viewed',
  'GPS_UPDATE_BLOCK': 'gps_update_block',
  'SHARED_MENU_VIEW_GOOGLE_SHEET_PAGE': 'shared_menu_view_google_sheet_page',
  'BUSINESS_INSIGHTS_V2_RATINGS_REVIEWS_VIEW': 'business_insights_v2_ratings_reviews_view',
  'VALIDATE_LOCATION_ERROR': 'validate_location_error',
  'CLICK_LINK': 'click_link',
  'RESOURCES': 'resources',
  'ORDER_DELIVERY': 'order_delivery',
  'CALENDAR': 'calendar',
  'OPEN_CREATE_VENUE_FORM': 'open_create_venue_form',
  'PUBLISH_VENUE': 'publish_venue',
  'SUBMIT_CREATE_VENUE_FORM': 'submit_create_venue_form',
  'DOWNLOAD': 'download',
  'ORDER_DETAILS': 'order_details',
  'DOWNLOAD_RECEIPT': 'download_receipt',
  'DOWNLOAD_ANNUAL_REPORT': 'download_annual_report',
  'ORDER_TRACKING': 'order_tracking',
  'CREATE_VENUE_GROUP_FAILED': 'create_venue_group_failed',
  'SUBMIT_FEEDBACK': 'submit_feedback',
  'LOAD': 'load',
  'GET_WOLT_PLUS': 'get_wolt_plus',
  'GET_WOLT_PLUS_CONFIRM': 'get_wolt_plus_confirm',
  'SUBSCRIPTION_RESULT_SUCCESS': 'subscription_result_success',
  'SUBSCRIPTION_RESULT_ERROR': 'subscription_result_error',
  'FETCH': 'fetch',
  'FORM_SUBMISSION_STATUS': 'form_submission_status',
  'REDEEM_BENEFIT': 'redeem_benefit',
  'EDGE_CAMPING_DETECTED': 'edge_camping_detected',
  'WOLT_PLUS_LEARN_MORE': 'wolt_plus_learn_more',
  'EXPAND_BENEFITS': 'expand_benefits',
  'GEO_AREA_FROM_URL': 'geo_area_from_url',
  'GO_ONLINE': 'go_online',
  'ADD_TIP': 'add_tip',
  'SEARCH_RESULTS': 'search_results',
  'BARCODE_SCAN_RESULTS': 'barcode_scan_results',
  'SAVING_ERROR': 'saving_error',
  'SAVING_SUCCESS': 'saving_success',
  'RECEIVING_SUCCESS': 'receiving_success',
  'RECEIVING_ERROR': 'receiving_error',
  'RECEIVING_LOADING': 'receiving_loading',
  'BARCODE_SCAN_ERROR': 'barcode_scan_error',
  'RECEIVING_BARCODE_SCAN_ERROR': 'receiving_barcode_scan_error',
} as const;
export type EventNameType = typeof EventName;
export type EventNameValueType = EventNameType[keyof EventNameType];

export const OperationType = {
  RECEIVING: 'receiving',
  SHRINKAGE: 'shrinkage',
  ADJUSTMENT: 'adjustment',
} as const;
export type OperationTypeType = typeof OperationType;
export type OperationTypeValueType = OperationTypeType[keyof OperationTypeType];

let WoltGatekeeper: any;

export function initAvo(
  options: {
    env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger;
  },
  destinationOptions: any,
  WoltGatekeeperDestination: CustomDestination,
) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn('[avo] ****************************************************');
    InternalAvoLogger.warn('[avo] WARNING Avo cannot be initialized in noop mode in production:');
    InternalAvoLogger.warn('[avo] - Overwriting configuration with noop=false.');
    InternalAvoLogger.warn(
      '[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true',
    );
    InternalAvoLogger.warn('[avo] ****************************************************');
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log('[avo] ****************************************************');
    InternalAvoLogger.log('[avo] Avo is now initialized in noop mode. This means:');
    InternalAvoLogger.log('[avo] - No events will be sent');
    InternalAvoLogger.log('[avo] - No network requests are made');
    InternalAvoLogger.log('[avo] ****************************************************');
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ =
    !__AVO_NOOP__ &&
    ((typeof window !== 'undefined' &&
      (window as any).location.search.indexOf('avo_debug=1') > -1) ||
      (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn('[avo] Avo Inspector not provided in initAvo() call');
  }

  destinationOptions = destinationOptions || {};

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position);
    }

    (function () {
      if (typeof (window as any) === 'undefined') {
        return;
      }
      let init = function () {
        let iframe: any = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.id = 'avo-debugger';
        iframe.src = 'https://www.avo.app/_debugger';
        iframe.style = 'display: none;';
      };

      if (document.body) {
        init();
      } else {
        document.addEventListener('DOMContentLoaded', init);
      }
    })();
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }

    WoltGatekeeper = WoltGatekeeperDestination;
    if (__AVO_ENV__ === 'prod') {
      WoltGatekeeper && WoltGatekeeper.make && WoltGatekeeper.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      WoltGatekeeper && WoltGatekeeper.make && WoltGatekeeper.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error'](
        '[avo] No staging key is set for Wolt - Gatekeeper. Head to destination settings in Avo to set a staging key.',
      );
      WoltGatekeeper && WoltGatekeeper.make && WoltGatekeeper.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertPurchaseOrderIndexOptional(
  purchaseOrderIndex: number | null | undefined,
  _label?: string,
) {
  let messages: AvoAssertMessage[] = [];
  if (purchaseOrderIndex !== undefined && purchaseOrderIndex !== null) {
    messages = messages.concat(
      AvoAssert.assertInt(
        'W3cZWZGVK',
        _label ? 'purchase_order_index' + ': ' + _label : 'purchase_order_index',
        purchaseOrderIndex,
      ),
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        'W3cZWZGVK',
        _label ? 'purchase_order_index' + ': ' + _label : 'purchase_order_index',
        0,
        purchaseOrderIndex,
      ),
    );
  }
  return messages;
}

function assertItemCount(itemCount: number, _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(
    AvoAssert.assertInt(
      'ZMcCzRWad2',
      _label ? 'item_count' + ': ' + _label : 'item_count',
      itemCount,
    ),
  );
  messages = messages.concat(
    AvoAssert.assertMin(
      'ZMcCzRWad2',
      _label ? 'item_count' + ': ' + _label : 'item_count',
      0,
      itemCount,
    ),
  );
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface AdjustmentItemReservationModalViewProperties {
  wmVenueId: string;
  gtin: string;
  catalogProductId: string;
  durationMs: number;
}
/**
 * adjustment_item_reservation_modal_view: Event is triggered when the modal that shows active item reservations pops up
 *
 * When to trigger this event:
 * 1. View is triggered when the modal pops up
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/xS677WT_gz/trigger/wctjlK9k2
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/xS677WT_gz}
 */
export function adjustmentItemReservationModalView(
  properties: AdjustmentItemReservationModalViewProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  eventPropertiesArray.push({
    id: 'Nu5Md_3-7D',
    name: 'duration_ms',
    value: properties.durationMs,
  });
  eventPropertiesArray.push({
    id: 'dLEBXcR0Ty',
    name: 'view',
    value: 'adjustment_item_reservation_modal',
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'xS677WT_gz',
        '5175d2d4023ab9450230aff63f66edcb9aab25fc61d1353d8faf7c9079eadb12',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'adjustment_item_reservation_modal_view',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'xS677WT_gz',
        'adjustment_item_reservation_modal_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'adjustment_item_reservation_modal_view',
        eventProperties,
        'xS677WT_gz',
        '5175d2d4023ab9450230aff63f66edcb9aab25fc61d1353d8faf7c9079eadb12',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'adjustment_item_reservation_modal_view',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AdjustmentItemReservationModalInteractionProperties {
  wmVenueId: string;
  gtin: string;
  catalogProductId: string;
  clickTarget: ClickTargetValueType;
}
/**
 * adjustment_item_reservation_modal_interaction: Event is triggered when the user clicks on one of the buttons in the modal
 *
 * When to trigger this event:
 * 1. Event is triggered when adjust later / adjust inventory button is clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/5VF0IOxhA/trigger/N6Zk6_x880
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/5VF0IOxhA}
 */
export function adjustmentItemReservationModalInteraction(
  properties: AdjustmentItemReservationModalInteractionProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({
    id: 'dLEBXcR0Ty',
    name: 'view',
    value: 'adjustment_item_reservation_modal',
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '5VF0IOxhA',
        '0310c298b2fc53193393e27cc7addb2c5129607f227cd699fa4e1cd126bb1ec5',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'adjustment_item_reservation_modal_interaction',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '5VF0IOxhA',
        'adjustment_item_reservation_modal_interaction',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'adjustment_item_reservation_modal_interaction',
        eventProperties,
        '5VF0IOxhA',
        '0310c298b2fc53193393e27cc7addb2c5129607f227cd699fa4e1cd126bb1ec5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'adjustment_item_reservation_modal_interaction',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface FeedbackToastViewProperties {
  wmVenueId: string;
  durationMs: number;
  operationType: OperationTypeValueType;
}
/**
 * feedback_toast_view: This view refers to the toast element where on can submit a feedback
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ims2yNSzpE/trigger/kkZtSNoq-
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.operationType: Shows which operation the feedback is related to (receiving, shrinkage or adjustments)
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ims2yNSzpE}
 */
export function feedbackToastView(properties: FeedbackToastViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'Nu5Md_3-7D',
    name: 'duration_ms',
    value: properties.durationMs,
  });
  eventPropertiesArray.push({
    id: 'x-Df_r4SG',
    name: 'operation_type',
    value: properties.operationType,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'feedback' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ims2yNSzpE',
        'ab6a694821ef14fa89d1c3bee796b7537656908ec3f12ae39392ba23e05302f2',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('feedback_toast_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ims2yNSzpE',
        'feedback_toast_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'feedback_toast_view',
        eventProperties,
        'ims2yNSzpE',
        'ab6a694821ef14fa89d1c3bee796b7537656908ec3f12ae39392ba23e05302f2',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('feedback_toast_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FeedbackToastDataProperties {
  wmVenueId: string;
  operationType: OperationTypeValueType;
  operationComment: string;
  operationRating: number;
}
/**
 * feedback_toast_data: This view refers to the toast element where on can submit a feedback
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JUtv0sc0r/trigger/fUnIAQngHw
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.operationType: Shows which operation the feedback is related to (receiving, shrinkage or adjustments)
 * @param properties.operationComment: Shows an additional comment sent by the user
 * @param properties.operationRating: Shows how the user rated an operation that (s)he completed
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JUtv0sc0r}
 */
export function feedbackToastData(properties: FeedbackToastDataProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'x-Df_r4SG',
    name: 'operation_type',
    value: properties.operationType,
  });
  eventPropertiesArray.push({
    id: 'M8tgpgI_N',
    name: 'operation_comment',
    value: properties.operationComment,
  });
  eventPropertiesArray.push({
    id: 'ymtlis9Uf',
    name: 'operation_rating',
    value: properties.operationRating,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'feedback' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'submit_feedback' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'JUtv0sc0r',
        '8d3159807db9550f786185de67da77b34335f27de1bfafdb070b44bc7ea31942',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('feedback_toast_data', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'JUtv0sc0r',
        'feedback_toast_data',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'feedback_toast_data',
        eventProperties,
        'JUtv0sc0r',
        '8d3159807db9550f786185de67da77b34335f27de1bfafdb070b44bc7ea31942',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('feedback_toast_data', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FeedbackToastInteractionSubmitProperties {
  wmVenueId: string;
  operationType: OperationTypeValueType;
}
/**
 * feedback_toast_interaction_submit: This view refers to the toast element where one can submit a feedback
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/40fY61rUG/trigger/KKXQ8xs7XY
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.operationType: Shows which operation the feedback is related to (receiving, shrinkage or adjustments)
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/40fY61rUG}
 */
export function feedbackToastInteractionSubmit(
  properties: FeedbackToastInteractionSubmitProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'x-Df_r4SG',
    name: 'operation_type',
    value: properties.operationType,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'feedback' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'submit' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '40fY61rUG',
        'befb5196abb75dff44a8bdf23e886b85af53d7ed4116673fe8c121fb38e117f9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'feedback_toast_interaction_submit',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '40fY61rUG',
        'feedback_toast_interaction_submit',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'feedback_toast_interaction_submit',
        eventProperties,
        '40fY61rUG',
        'befb5196abb75dff44a8bdf23e886b85af53d7ed4116673fe8c121fb38e117f9',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'feedback_toast_interaction_submit',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface FeedbackToastInteractionRatingProperties {
  wmVenueId: string;
  operationType: OperationTypeValueType;
  operationRating: number;
}
/**
 * feedback_toast_interaction_rating: This view refers to the toast element where on can submit a feedback
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MYYHW1kKH/trigger/ePeCiNja9G
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.operationType: Shows which operation the feedback is related to (receiving, shrinkage or adjustments)
 * @param properties.operationRating: Shows how the user rated an operation that (s)he completed
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MYYHW1kKH}
 */
export function feedbackToastInteractionRating(
  properties: FeedbackToastInteractionRatingProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'x-Df_r4SG',
    name: 'operation_type',
    value: properties.operationType,
  });
  eventPropertiesArray.push({
    id: 'ymtlis9Uf',
    name: 'operation_rating',
    value: properties.operationRating,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'feedback' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'rating' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MYYHW1kKH',
        '9eec4b6fc91673270cf8bdeb3d68bd2af4fdf9cf42f887c3008229114b6bc77f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'feedback_toast_interaction_rating',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MYYHW1kKH',
        'feedback_toast_interaction_rating',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'feedback_toast_interaction_rating',
        eventProperties,
        'MYYHW1kKH',
        '9eec4b6fc91673270cf8bdeb3d68bd2af4fdf9cf42f887c3008229114b6bc77f',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'feedback_toast_interaction_rating',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface FeedbackToastInteractionCloseProperties {
  wmVenueId: string;
  operationType: OperationTypeValueType;
}
/**
 * feedback_toast_interaction_close: This view refers to the toast element where on can submit a feedback
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/UnFGXhaLq/trigger/sM6DyDT_AH
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.operationType: Shows which operation the feedback is related to (receiving, shrinkage or adjustments)
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/UnFGXhaLq}
 */
export function feedbackToastInteractionClose(properties: FeedbackToastInteractionCloseProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'x-Df_r4SG',
    name: 'operation_type',
    value: properties.operationType,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'feedback' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'close' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'UnFGXhaLq',
        '0e06763aee29f3b474bf7d3caa96b42e4662bd6e06add3292ac9f8d4d667acbe',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'feedback_toast_interaction_close',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'UnFGXhaLq',
        'feedback_toast_interaction_close',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'feedback_toast_interaction_close',
        eventProperties,
        'UnFGXhaLq',
        '0e06763aee29f3b474bf7d3caa96b42e4662bd6e06add3292ac9f8d4d667acbe',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'feedback_toast_interaction_close',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface FeedbackToastInteractionCommentProperties {
  wmVenueId: string;
  operationType: OperationTypeValueType;
}
/**
 * feedback_toast_interaction_comment: This view refers to the toast element where on can submit a feedback
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/tsri7A_BK/trigger/DcchP9eifK
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.operationType: Shows which operation the feedback is related to (receiving, shrinkage or adjustments)
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/tsri7A_BK}
 */
export function feedbackToastInteractionComment(
  properties: FeedbackToastInteractionCommentProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'x-Df_r4SG',
    name: 'operation_type',
    value: properties.operationType,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'feedback' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'comment' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tsri7A_BK',
        '391cb660b21d5ea93aa47d60dc6aceb130abf4f11d7d56560e1c1fde5e4903a4',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'feedback_toast_interaction_comment',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'tsri7A_BK',
        'feedback_toast_interaction_comment',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'feedback_toast_interaction_comment',
        eventProperties,
        'tsri7A_BK',
        '391cb660b21d5ea93aa47d60dc6aceb130abf4f11d7d56560e1c1fde5e4903a4',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'feedback_toast_interaction_comment',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AddToInventoryInteractionBatchClickProperties {
  wmVenueId: string;
  gtin: string | null | undefined;
  catalogProductId: string;
  clickTarget: ClickTargetValueType;
  batchCount: number;
}
/**
 * add_to_inventory_interaction_batch_click: This event is sent when a user clicks to add another batch

NOTE: if the recently added batch is removed, then click_target should be "remove_batch"
 *
 * When to trigger this event:
 * 1. Click to add another batch
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/AgFkZB58q/trigger/_5uMVZDtn
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 * @param properties.batchCount: Shows the number of batches
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/AgFkZB58q}
 */
export function addToInventoryInteractionBatchClick(
  properties: AddToInventoryInteractionBatchClickProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({ id: 'hPfuDjueR', name: 'batch_count', value: properties.batchCount });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'AgFkZB58q',
        '3b97566dd9a5b95355fd28eb1982857bea0e210a68639d5d1e259d99331f300a',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'add_to_inventory_interaction_batch_click',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'AgFkZB58q',
        'add_to_inventory_interaction_batch_click',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'add_to_inventory_interaction_batch_click',
        eventProperties,
        'AgFkZB58q',
        '3b97566dd9a5b95355fd28eb1982857bea0e210a68639d5d1e259d99331f300a',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'add_to_inventory_interaction_batch_click',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingDataSearchResultsProperties {
  wmVenueId: string;
  searchValue: string;
  resultsCount: number;
}
/**
 * receiving_data_search_results: Event is triggered when the user types something to the search bar
 *
 * When to trigger this event:
 * 1. This is triggered when the user types something into the search bar
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/rdw20ra_A1/trigger/c-hmtGOd6
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.searchValue: What the user typed in the search bar.
 * @param properties.resultsCount: Number of items shown in the search results.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/rdw20ra_A1}
 */
export function receivingDataSearchResults(properties: ReceivingDataSearchResultsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'jxYEq3u-t',
    name: 'search_value',
    value: properties.searchValue,
  });
  eventPropertiesArray.push({
    id: 'OAR_pgU_u',
    name: 'results_count',
    value: properties.resultsCount,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'search_results' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'rdw20ra_A1',
        '662f7c2a144c139bea3c8519a17ae4aea5c386566873f3a6532593066c9e0093',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'receiving_data_search_results',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'rdw20ra_A1',
        'receiving_data_search_results',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_data_search_results',
        eventProperties,
        'rdw20ra_A1',
        '662f7c2a144c139bea3c8519a17ae4aea5c386566873f3a6532593066c9e0093',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_data_search_results',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingDataBarcodeScanResultsProperties {
  wmVenueId: string;
  barcode: string;
  resultsCount: number;
  purchaseOrderCount: number;
  barcodeScanType: string;
}
/**
 * receiving_data_barcode_scan_results: The event is triggered when the user scans an item barcode.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.barcode: Barcode that was scanned.
 * @param properties.resultsCount: Number of items shown in the search results.
 * @param properties.purchaseOrderCount: Total count of purchase orders displayed on the page.
 * @param properties.barcodeScanType: Type of the barcode scanned (outer case or item).
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/imEUo1CQxx}
 */
export function receivingDataBarcodeScanResults(
  properties: ReceivingDataBarcodeScanResultsProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({ id: '1Tm5GInra', name: 'barcode', value: properties.barcode });
  eventPropertiesArray.push({
    id: 'OAR_pgU_u',
    name: 'results_count',
    value: properties.resultsCount,
  });
  eventPropertiesArray.push({
    id: 'ipY75tiMy',
    name: 'purchase_order_count',
    value: properties.purchaseOrderCount,
  });
  eventPropertiesArray.push({
    id: 'gT9-ATrpR',
    name: 'barcode_scan_type',
    value: properties.barcodeScanType,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({
    id: 'r5E-SMeZ21',
    name: 'event_name',
    value: 'barcode_scan_results',
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'imEUo1CQxx',
        '2ccfbf39d176a7de2daaa06e0ff7f605fb000546f2f68abf076002734e21d4f5',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'receiving_data_barcode_scan_results',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'imEUo1CQxx',
        'receiving_data_barcode_scan_results',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_data_barcode_scan_results',
        eventProperties,
        'imEUo1CQxx',
        '2ccfbf39d176a7de2daaa06e0ff7f605fb000546f2f68abf076002734e21d4f5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_data_barcode_scan_results',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface RecevingViewProperties {
  wmVenueId: string;
}
/**
 * receving_view: This view refers to the landing screen for receiving, where the user can scan the barcode of an item/outer case or search by item name.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZNDB-xTDl9}
 */
export function recevingView(properties: RecevingViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ZNDB-xTDl9',
        'e473ab7383af53a6f11256098a833307c42aeab010c4ba5e7c773322ccebbed2',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('receving_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ZNDB-xTDl9',
        'receving_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receving_view',
        eventProperties,
        'ZNDB-xTDl9',
        'e473ab7383af53a6f11256098a833307c42aeab010c4ba5e7c773322ccebbed2',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('receving_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReceivingViewProperties {
  wmVenueId: string;
  purchaseOrderCount: number;
  durationMs: number;
}
/**
 * receiving_view: This view refers to the landing screen for receiving, where the user can scan the barcode of an item/outer case or search by item name.
 *
 * When to trigger this event:
 * 1. Landing screen for receiving, where the user can scan the barcode of an item/outer case, search by item name, or check which POs are arriving.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/eH-VuWgxz7/trigger/mNlVRvqQH
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.purchaseOrderCount: Total count of purchase orders displayed on the page.
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/eH-VuWgxz7}
 */
export function receivingView(properties: ReceivingViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'ipY75tiMy',
    name: 'purchase_order_count',
    value: properties.purchaseOrderCount,
  });
  eventPropertiesArray.push({
    id: 'Nu5Md_3-7D',
    name: 'duration_ms',
    value: properties.durationMs,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'eH-VuWgxz7',
        'c8aec2faded061d2643e81fd9d919adb49aed99f95f7df044064c12f8c57c097',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('receiving_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'eH-VuWgxz7',
        'receiving_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_view',
        eventProperties,
        'eH-VuWgxz7',
        'c8aec2faded061d2643e81fd9d919adb49aed99f95f7df044064c12f8c57c097',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('receiving_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReceivingInteractionClickSearchResultsProperties {
  wmVenueId: string;
  itemIndex: number;
  catalogProductId: string;
  gtin: string | null | undefined;
  purchaseOrderPublicId: string | null | undefined;
  purchaseOrderIndex: number | null | undefined;
  clickTarget: ClickTargetValueType;
}
/**
 * receiving_interaction_click_search_results: Interaction event that shows what items in the results the user interacted with. The click can be done on the purchase orders section, search results, or barcode scan.

Note: The click_target property should contain the value where the click happened  "search_results".
 *
 * When to trigger this event:
 * 1. Click on the items from the search results.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/pMj7hTPyfE/trigger/luLwt_19y
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.itemIndex: Shows an index of the item in the section. Starts with 0
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.purchaseOrderIndex: Shows the index of the purchase order of the items interacted with.
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/pMj7hTPyfE}
 */
export function receivingInteractionClickSearchResults(
  properties: ReceivingInteractionClickSearchResultsProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'QDjJR5tHfS5p',
    name: 'item_index',
    value: properties.itemIndex,
  });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  properties.purchaseOrderIndex !== undefined && properties.purchaseOrderIndex !== null
    ? eventPropertiesArray.push({
        id: 'W3cZWZGVK',
        name: 'purchase_order_index',
        value: properties.purchaseOrderIndex,
      })
    : eventPropertiesArray.push({ id: 'W3cZWZGVK', name: 'purchase_order_index', value: null });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPurchaseOrderIndexOptional(properties.purchaseOrderIndex));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'pMj7hTPyfE',
        '861f465a743fdf587784643331500bf5f8fd71c70a31dbbf08e425cf26c7123c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'receiving_interaction_click_search_results',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'pMj7hTPyfE',
        'receiving_interaction_click_search_results',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'receiving_interaction_click_search_results': " +
            messages[0]!.message,
        );
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_interaction_click_search_results',
        eventProperties,
        'pMj7hTPyfE',
        '861f465a743fdf587784643331500bf5f8fd71c70a31dbbf08e425cf26c7123c',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_interaction_click_search_results',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingComponentsInteractionProperties {
  eventName: EventNameValueType;
  logType: LogTypeValueType;
  view: ViewValueType;
}
/**
 * receiving_components_interaction: Non-item interactions on receiving screen
 *
 * @param properties the properties associatied with this event
 * @param properties.eventName: Name of the event according to Wolt internal specifications
 * @param properties.logType: Typology of log according to Wolt internal specifications
 * @param properties.view: Describes the context of which view the event was originated
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/qiejsaHMd6}
 */
export function receivingComponentsInteraction(
  properties: ReceivingComponentsInteractionProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: properties.eventName });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: properties.logType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qiejsaHMd6',
        'f8cf4954b726ccccf9e2ba51a8bfd3b821b4e91ab5a3fa5ebc3bcd18e221a4d3',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'receiving_components_interaction',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'qiejsaHMd6',
        'receiving_components_interaction',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_components_interaction',
        eventProperties,
        'qiejsaHMd6',
        'f8cf4954b726ccccf9e2ba51a8bfd3b821b4e91ab5a3fa5ebc3bcd18e221a4d3',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_components_interaction',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingBarcodeScanViewProperties {
  wmVenueId: string;
  catalogProductId: string | null | undefined;
  gtin: string;
  durationMs: number;
  barcodeScanType: string;
}
/**
 * receiving_barcode_scan_view: This view refers to the landing screen for the barcode scan.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.barcodeScanType: Type of the barcode scanned (outer case or item).
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/2yu4UNbq2}
 */
export function receivingBarcodeScanView(properties: ReceivingBarcodeScanViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.catalogProductId !== undefined && properties.catalogProductId !== null
    ? eventPropertiesArray.push({
        id: 'zff8fhnPm',
        name: 'catalog_product_id',
        value: properties.catalogProductId,
      })
    : eventPropertiesArray.push({ id: 'zff8fhnPm', name: 'catalog_product_id', value: null });
  eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin });
  eventPropertiesArray.push({
    id: 'Nu5Md_3-7D',
    name: 'duration_ms',
    value: properties.durationMs,
  });
  eventPropertiesArray.push({
    id: 'gT9-ATrpR',
    name: 'barcode_scan_type',
    value: properties.barcodeScanType,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'barcode_scan' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '2yu4UNbq2',
        '36d3dea0a867e8056961e53595f1b847bb1b9a77fff232a0351a155f625fd337',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('receiving_barcode_scan_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '2yu4UNbq2',
        'receiving_barcode_scan_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_barcode_scan_view',
        eventProperties,
        '2yu4UNbq2',
        '36d3dea0a867e8056961e53595f1b847bb1b9a77fff232a0351a155f625fd337',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_barcode_scan_view',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingInteractionClickPurchaseOrdersProperties {
  wmVenueId: string;
  itemIndex: number;
  catalogProductId: string;
  gtin: string | null | undefined;
  purchaseOrderPublicId: string;
  purchaseOrderIndex: number | null | undefined;
  clickTarget: ClickTargetValueType;
}
/**
 * receiving_interaction_click_purchase_orders: Interaction event that shows what items in the results the user interacted with. The click can be done on the purchase orders section, search results, or barcode scan.

Note: The click_target property should contain the value "purchase_orders".
 *
 * When to trigger this event:
 * 1. Click on the items from a purchase order. 
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/lilt2IAVp/trigger/4M2nwmcuy
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.itemIndex: Shows an index of the item in the section. Starts with 0
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.purchaseOrderIndex: Shows the index of the purchase order of the items interacted with.
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/lilt2IAVp}
 */
export function receivingInteractionClickPurchaseOrders(
  properties: ReceivingInteractionClickPurchaseOrdersProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'QDjJR5tHfS5p',
    name: 'item_index',
    value: properties.itemIndex,
  });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'xtq8g-Ale',
    name: 'purchase_order_public_id',
    value: properties.purchaseOrderPublicId,
  });
  properties.purchaseOrderIndex !== undefined && properties.purchaseOrderIndex !== null
    ? eventPropertiesArray.push({
        id: 'W3cZWZGVK',
        name: 'purchase_order_index',
        value: properties.purchaseOrderIndex,
      })
    : eventPropertiesArray.push({ id: 'W3cZWZGVK', name: 'purchase_order_index', value: null });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPurchaseOrderIndexOptional(properties.purchaseOrderIndex));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'lilt2IAVp',
        '643aa8cb39217b80a405b2566343b0227390e2578e3cf0264237ea8592fc3d6f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'receiving_interaction_click_purchase_orders',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'lilt2IAVp',
        'receiving_interaction_click_purchase_orders',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'receiving_interaction_click_purchase_orders': " +
            messages[0]!.message,
        );
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_interaction_click_purchase_orders',
        eventProperties,
        'lilt2IAVp',
        '643aa8cb39217b80a405b2566343b0227390e2578e3cf0264237ea8592fc3d6f',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_interaction_click_purchase_orders',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingInteractionClickRecentlyAddedItemsProperties {
  wmVenueId: string;
  clickTarget: ClickTargetValueType;
}
/**
 * receiving_interaction_click_recently_added_items: General click events on the Receiving screen.

Note: The click_target property should contain the value where the click happened "recently_added_items".
 *
 * When to trigger this event:
 * 1. Click on the Recently Added Items in the Receiving screen.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/1Sqjco0uM/trigger/m1Urto73E
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/1Sqjco0uM}
 */
export function receivingInteractionClickRecentlyAddedItems(
  properties: ReceivingInteractionClickRecentlyAddedItemsProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '1Sqjco0uM',
        '80f83de3e4a4669b04ff6d5fabd890a99040b3098e7eb7c1b9b64bc834cadd55',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'receiving_interaction_click_recently_added_items',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '1Sqjco0uM',
        'receiving_interaction_click_recently_added_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_interaction_click_recently_added_items',
        eventProperties,
        '1Sqjco0uM',
        '80f83de3e4a4669b04ff6d5fabd890a99040b3098e7eb7c1b9b64bc834cadd55',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_interaction_click_recently_added_items',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingInteractionClickBackProperties {
  wmVenueId: string;
  clickTarget: ClickTargetValueType;
}
/**
 * receiving_interaction_click_back: General click events on the Receiving screen.

Note: The click_target property should contain the value where the click happened "back".
 *
 * When to trigger this event:
 * 1. Click on the back button events on the Receiving screen.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/5xDKq0FiA/trigger/KOyVlJBqU
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/5xDKq0FiA}
 */
export function receivingInteractionClickBack(properties: ReceivingInteractionClickBackProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '5xDKq0FiA',
        '186f568cd9330bf359a360f479cf87fd04d3ee212dbd8b4c9e563f2815fc7731',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'receiving_interaction_click_back',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '5xDKq0FiA',
        'receiving_interaction_click_back',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_interaction_click_back',
        eventProperties,
        '5xDKq0FiA',
        '186f568cd9330bf359a360f479cf87fd04d3ee212dbd8b4c9e563f2815fc7731',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_interaction_click_back',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingInteractionClickUserGuidesProperties {
  wmVenueId: string;
  clickTarget: ClickTargetValueType;
}
/**
 * receiving_interaction_click_user_guides: General click events on the Receiving screen.

Note: The click_target property should contain the value where the click happened "user_guides".
 *
 * When to trigger this event:
 * 1. Click on the user guide present in the Receiving screen.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/btddoaGHY/trigger/I5MZzAo0s
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/btddoaGHY}
 */
export function receivingInteractionClickUserGuides(
  properties: ReceivingInteractionClickUserGuidesProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'receiving' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'btddoaGHY',
        '141296bd68f17ea5b6daca728416f88a8fe196bc59a8db2342a3b6d6d58ad145',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'receiving_interaction_click_user_guides',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'btddoaGHY',
        'receiving_interaction_click_user_guides',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_interaction_click_user_guides',
        eventProperties,
        'btddoaGHY',
        '141296bd68f17ea5b6daca728416f88a8fe196bc59a8db2342a3b6d6d58ad145',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_interaction_click_user_guides',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface RecentlyAddedItemsViewProperties {
  wmVenueId: string;
  durationMs: number;
  itemCount: number;
}
/**
 * recently_added_items_view: This view refers to the recently added items screen accessed from the receiving view right top corner icon.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.itemCount: Total number of non-unique items: 2 units of item_id = 1 and 3 units of item_id = 2 will give item_count = 5
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/h-CdHidsY}
 */
export function recentlyAddedItemsView(properties: RecentlyAddedItemsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'Nu5Md_3-7D',
    name: 'duration_ms',
    value: properties.durationMs,
  });
  eventPropertiesArray.push({ id: 'ZMcCzRWad2', name: 'item_count', value: properties.itemCount });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'recently_added_items' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItemCount(properties.itemCount));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'h-CdHidsY',
        '6dfa2ec3edeb8d0af866e322411144a2e8b6efb18f502d430c576360e5fc9542',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('recently_added_items_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'h-CdHidsY',
        'recently_added_items_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'recently_added_items_view': " + messages[0]!.message);
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'recently_added_items_view',
        eventProperties,
        'h-CdHidsY',
        '6dfa2ec3edeb8d0af866e322411144a2e8b6efb18f502d430c576360e5fc9542',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'recently_added_items_view',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface RecentlyAddedItemsInteractionClickEditProperties {
  wmVenueId: string;
  clickTarget: ClickTargetValueType;
  catalogProductId: string;
  gtin: string | null | undefined;
  purchaseOrderPublicId: string | null | undefined;
  referenceId: string | null | undefined;
}
/**
 * recently_added_items_interaction_click_edit: General click events on the Receiving screen.

Note: The click_target property should contain the value where the click happened ("edit_item").
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.referenceId: Reference id for received itms when purchase order can't be found / items are not part of PO
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/furfw-D9B}
 */
export function recentlyAddedItemsInteractionClickEdit(
  properties: RecentlyAddedItemsInteractionClickEditProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  properties.referenceId !== undefined && properties.referenceId !== null
    ? eventPropertiesArray.push({
        id: 'kZBVHn9k7',
        name: 'reference_id',
        value: properties.referenceId,
      })
    : eventPropertiesArray.push({ id: 'kZBVHn9k7', name: 'reference_id', value: null });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'recently_added_items' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'furfw-D9B',
        'fd6a6ac421d3c7d6098d8b79ac909cd4065df5469d977e558b26207c20555af6',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'recently_added_items_interaction_click_edit',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'furfw-D9B',
        'recently_added_items_interaction_click_edit',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'recently_added_items_interaction_click_edit',
        eventProperties,
        'furfw-D9B',
        'fd6a6ac421d3c7d6098d8b79ac909cd4065df5469d977e558b26207c20555af6',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'recently_added_items_interaction_click_edit',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface EditReceivingEventViewProperties {
  wmVenueId: string;
  durationMs: number;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
  batchCount: number;
  gtin: string | null | undefined;
}
/**
 * edit_receiving_event_view: This view refers to editing receiving event accessed from Recently added items.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.batchCount: Shows the number of batches
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/zKKQWVOkS}
 */
export function editReceivingEventView(properties: EditReceivingEventViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'Nu5Md_3-7D',
    name: 'duration_ms',
    value: properties.durationMs,
  });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({ id: 'hPfuDjueR', name: 'batch_count', value: properties.batchCount });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'edit_receiving_event' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'zKKQWVOkS',
        '11cc9ab5b5d21b0918d2d8a8723e064ab029f4ad125816a1a270665365e7f3b9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('edit_receiving_event_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'zKKQWVOkS',
        'edit_receiving_event_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'edit_receiving_event_view',
        eventProperties,
        'zKKQWVOkS',
        '11cc9ab5b5d21b0918d2d8a8723e064ab029f4ad125816a1a270665365e7f3b9',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'edit_receiving_event_view',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface EditReceivingEventInteractionClickAddInventoryProperties {
  wmVenueId: string;
  clickTarget: ClickTargetValueType;
  gtin: string | null | undefined;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
  batchCount: number;
  editedBatchCount: number;
  editedQuantityBatchCount: number;
  editedExpirationBatchCount: number;
  editedLocationBatchCount: number;
}
/**
 * edit_receiving_event_interaction_click_add_inventory: Click on to add the inventory screen. It can be to save the changes or to cancel the changes.

NOTE: The click_target property should be "cancel" or "save".
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.batchCount: Shows the number of batches
 * @param properties.editedBatchCount: Shows how many batches items were received for.
 * @param properties.editedQuantityBatchCount: Shows for how many batches quantity was added
 * @param properties.editedExpirationBatchCount: Shows for how many batches expiry date was added
 * @param properties.editedLocationBatchCount: Shows for how many batches location was added
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/OR_9xctkM}
 */
export function editReceivingEventInteractionClickAddInventory(
  properties: EditReceivingEventInteractionClickAddInventoryProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({ id: 'hPfuDjueR', name: 'batch_count', value: properties.batchCount });
  eventPropertiesArray.push({
    id: 'WeNfIeGI8',
    name: 'edited_batch_count',
    value: properties.editedBatchCount,
  });
  eventPropertiesArray.push({
    id: '-ZEMg_mRS',
    name: 'edited_quantity_batch_count',
    value: properties.editedQuantityBatchCount,
  });
  eventPropertiesArray.push({
    id: 'YME8Vkz3S',
    name: 'edited_expiration_batch_count',
    value: properties.editedExpirationBatchCount,
  });
  eventPropertiesArray.push({
    id: 'qOwAzAKdK',
    name: 'edited_location_batch_count',
    value: properties.editedLocationBatchCount,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'edit_receiving_event' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'OR_9xctkM',
        '3f9cb7c7ee37114de3104703f38000228442641b6ea5e55d8c767999fb9e974a',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'edit_receiving_event_interaction_click_add_inventory',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'OR_9xctkM',
        'edit_receiving_event_interaction_click_add_inventory',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'edit_receiving_event_interaction_click_add_inventory',
        eventProperties,
        'OR_9xctkM',
        '3f9cb7c7ee37114de3104703f38000228442641b6ea5e55d8c767999fb9e974a',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'edit_receiving_event_interaction_click_add_inventory',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface EditReceivingEventInteractionClickBatchRemoveProperties {
  wmVenueId: string;
  clickTarget: ClickTargetValueType;
  gtin: string | null | undefined;
  batchId: string;
}
/**
 * edit_receiving_event_interaction_click_batch_remove: Click on batch-level button to remove the batch.

NOTE: The click_target property should be "remove_batch".
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.batchId: Id of the batch user interacted with
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/XEGkGrrsh}
 */
export function editReceivingEventInteractionClickBatchRemove(
  properties: EditReceivingEventInteractionClickBatchRemoveProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({ id: 'KAicEO4tk', name: 'batch_id', value: properties.batchId });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'edit_receiving_event' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'XEGkGrrsh',
        '12875a0319a944e0ce0415417c43cfdfef6c6565dd3d8ed737dba24222ccc238',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'edit_receiving_event_interaction_click_batch_remove',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'XEGkGrrsh',
        'edit_receiving_event_interaction_click_batch_remove',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'edit_receiving_event_interaction_click_batch_remove',
        eventProperties,
        'XEGkGrrsh',
        '12875a0319a944e0ce0415417c43cfdfef6c6565dd3d8ed737dba24222ccc238',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'edit_receiving_event_interaction_click_batch_remove',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface EditReceivingEventSavingErrorProperties {
  wmVenueId: string;
  gtin: string | null | undefined;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
  errorMessage: string;
  errorCode: string | null | undefined;
}
/**
 * edit_receiving_event_saving_error: Save screen errors that might happen if the user adds an invalid input.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.errorMessage: Another type of error message returned by the backend (EN)
 * @param properties.errorCode: Error code returned in case of errors by external APIs or Wolt's backend
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/LchvefPf0Y}
 */
export function editReceivingEventSavingError(properties: EditReceivingEventSavingErrorProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({
    id: 'n16SoEsnz8od',
    name: 'error_message',
    value: properties.errorMessage,
  });
  properties.errorCode !== undefined && properties.errorCode !== null
    ? eventPropertiesArray.push({
        id: 'E7vIC0AkfLhJ',
        name: 'error_code',
        value: properties.errorCode,
      })
    : eventPropertiesArray.push({ id: 'E7vIC0AkfLhJ', name: 'error_code', value: null });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'edit_receiving_event' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'saving_error' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'error' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'LchvefPf0Y',
        'f2808eb07aa49ab0e0e6380c033742306db29e4cfc6bb63723f5543b050af4b3',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'edit_receiving_event_saving_error',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'LchvefPf0Y',
        'edit_receiving_event_saving_error',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'edit_receiving_event_saving_error',
        eventProperties,
        'LchvefPf0Y',
        'f2808eb07aa49ab0e0e6380c033742306db29e4cfc6bb63723f5543b050af4b3',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'edit_receiving_event_saving_error',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface EditReceivingEventSavingSuccessProperties {
  wmVenueId: string;
  gtin: string | null | undefined;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
  editedBatchCount: number;
}
/**
 * edit_receiving_event_saving_success: Adding items done popup screen.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.editedBatchCount: Shows how many batches items were received for.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/v0rIU7vWz}
 */
export function editReceivingEventSavingSuccess(
  properties: EditReceivingEventSavingSuccessProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({
    id: 'WeNfIeGI8',
    name: 'edited_batch_count',
    value: properties.editedBatchCount,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'edit_receiving_event' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'saving_success' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'v0rIU7vWz',
        '7c68701e159a79fd16c01e082ecaac69f5587e04649feab0f467b4f4cb7a8de0',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'edit_receiving_event_saving_success',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'v0rIU7vWz',
        'edit_receiving_event_saving_success',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'edit_receiving_event_saving_success',
        eventProperties,
        'v0rIU7vWz',
        '7c68701e159a79fd16c01e082ecaac69f5587e04649feab0f467b4f4cb7a8de0',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'edit_receiving_event_saving_success',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AddToInventoryViewProperties {
  wmVenueId: string;
  catalogProductId: string;
  gtin: string | null | undefined;
  purchaseOrderPublicId: string | null | undefined;
  referenceId: string | null | undefined;
}
/**
 * add_to_inventory_view: This view refers to the Add to Inventory screen that allows users to add units to inventory.
 *
 * When to trigger this event:
 * 1. Refers to the Add to Inventory screen that allows users to add units to inventory.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/PaZuMGuOw/trigger/kv70cWmXh
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.referenceId: Reference id for received itms when purchase order can't be found / items are not part of PO
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/PaZuMGuOw}
 */
export function addToInventoryView(properties: AddToInventoryViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  properties.referenceId !== undefined && properties.referenceId !== null
    ? eventPropertiesArray.push({
        id: 'kZBVHn9k7',
        name: 'reference_id',
        value: properties.referenceId,
      })
    : eventPropertiesArray.push({ id: 'kZBVHn9k7', name: 'reference_id', value: null });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'add_to_inventory' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'PaZuMGuOw',
        'b4a22ef9ec1f5f76b16395ababf2b1b54b4b22ffa72fb5ba5601a3446a22ff3d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('add_to_inventory_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'PaZuMGuOw',
        'add_to_inventory_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'add_to_inventory_view',
        eventProperties,
        'PaZuMGuOw',
        'b4a22ef9ec1f5f76b16395ababf2b1b54b4b22ffa72fb5ba5601a3446a22ff3d',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('add_to_inventory_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddToInventoryInteractionClickProperties {
  wmVenueId: string;
  gtin: string | null | undefined;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
  expectedQuantity: number;
  quantityTotal: number;
  batchCount: number;
  addedExpirationBatchCount: number;
  addedLocationBatchCount: number;
  clickTarget: ClickTargetValueType;
}
/**
 * add_to_inventory_interaction_click: Click on add to the inventory screen.

NOTE: the click_target can be "add_to_inventory" or "cancel".
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.expectedQuantity: How many items a store was expecting to receive with this order
 * @param properties.quantityTotal: What the user typed in the quantity field (sum of quantities if multiple batches)
 * @param properties.batchCount: Shows the number of batches
 * @param properties.addedExpirationBatchCount: Shows for how many batches expiry date was added
 * @param properties.addedLocationBatchCount: Shows for how many batches location was added
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/CJ7uBGSlZU}
 */
export function addToInventoryInteractionClick(
  properties: AddToInventoryInteractionClickProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({
    id: 'TEXEDakbe',
    name: 'expected_quantity',
    value: properties.expectedQuantity,
  });
  eventPropertiesArray.push({
    id: 'yow_V1n1r',
    name: 'quantity_total',
    value: properties.quantityTotal,
  });
  eventPropertiesArray.push({ id: 'hPfuDjueR', name: 'batch_count', value: properties.batchCount });
  eventPropertiesArray.push({
    id: 'VBdd-SrJd',
    name: 'added_expiration_batch_count',
    value: properties.addedExpirationBatchCount,
  });
  eventPropertiesArray.push({
    id: 'T8TZXPBee',
    name: 'added_location_batch_count',
    value: properties.addedLocationBatchCount,
  });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'add_to_inventory' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'CJ7uBGSlZU',
        '83e3ae2140bbb5115c673fbb44d1c43fd77a5e2ec021525e40db714e2c5ddb22',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'add_to_inventory_interaction_click',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'CJ7uBGSlZU',
        'add_to_inventory_interaction_click',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'add_to_inventory_interaction_click',
        eventProperties,
        'CJ7uBGSlZU',
        '83e3ae2140bbb5115c673fbb44d1c43fd77a5e2ec021525e40db714e2c5ddb22',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'add_to_inventory_interaction_click',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AddToInventoryInteractionScreenEventsClickProperties {
  wmVenueId: string;
  gtin: string | null | undefined;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
  clickTarget: ClickTargetValueType;
}
/**
 * add_to_inventory_interaction_screen_events_click: Click on interaction events on add to inventory screen

NOTE: the click_target can be"show_more_info", "show_shipment_info", "add_another_batch", "expiration_date", "unit_quantity" or "add_to_location".
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/qmg46ZxG6}
 */
export function addToInventoryInteractionScreenEventsClick(
  properties: AddToInventoryInteractionScreenEventsClickProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'add_to_inventory' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qmg46ZxG6',
        'afdd48fec9022434487c75eceae0d17e515090718331742ec132fecdb8d7c736',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'add_to_inventory_interaction_screen_events_click',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'qmg46ZxG6',
        'add_to_inventory_interaction_screen_events_click',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'add_to_inventory_interaction_screen_events_click',
        eventProperties,
        'qmg46ZxG6',
        'afdd48fec9022434487c75eceae0d17e515090718331742ec132fecdb8d7c736',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'add_to_inventory_interaction_screen_events_click',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AddToInventoryEventReceivingErrorProperties {
  wmVenueId: string;
  gtin: string | null | undefined;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
  errorMessage: string;
  errorCode: string | null | undefined;
}
/**
 * add_to_inventory_event_receiving_error: Add to inventory screen errors that might happen if the user adds an invalid input.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.errorMessage: Another type of error message returned by the backend (EN)
 * @param properties.errorCode: Error code returned in case of errors by external APIs or Wolt's backend
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/mixbczz9g}
 */
export function addToInventoryEventReceivingError(
  properties: AddToInventoryEventReceivingErrorProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({
    id: 'n16SoEsnz8od',
    name: 'error_message',
    value: properties.errorMessage,
  });
  properties.errorCode !== undefined && properties.errorCode !== null
    ? eventPropertiesArray.push({
        id: 'E7vIC0AkfLhJ',
        name: 'error_code',
        value: properties.errorCode,
      })
    : eventPropertiesArray.push({ id: 'E7vIC0AkfLhJ', name: 'error_code', value: null });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'add_to_inventory' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'receiving_error' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'error' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'mixbczz9g',
        '638aa99df7448d875b7a63b241b3cc4fcbcda2ca9bd8be3b96dd268211d93d48',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'add_to_inventory_event_receiving_error',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'mixbczz9g',
        'add_to_inventory_event_receiving_error',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'add_to_inventory_event_receiving_error',
        eventProperties,
        'mixbczz9g',
        '638aa99df7448d875b7a63b241b3cc4fcbcda2ca9bd8be3b96dd268211d93d48',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'add_to_inventory_event_receiving_error',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AddToInventoryEventReceivingSuccessProperties {
  wmVenueId: string;
  gtin: string | null | undefined;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
  batchCount: number;
}
/**
 * add_to_inventory_event_receiving_success: Adding items done popup screen.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 * @param properties.batchCount: Shows the number of batches
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/x9FAOrsMK}
 */
export function addToInventoryEventReceivingSuccess(
  properties: AddToInventoryEventReceivingSuccessProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({ id: 'hPfuDjueR', name: 'batch_count', value: properties.batchCount });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'add_to_inventory' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'receiving_success' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'x9FAOrsMK',
        '83293d08183052fe7f42951a853e2cdddfaeedb2a1e366021b2973517b3ca6c6',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'add_to_inventory_event_receiving_success',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'x9FAOrsMK',
        'add_to_inventory_event_receiving_success',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'add_to_inventory_event_receiving_success',
        eventProperties,
        'x9FAOrsMK',
        '83293d08183052fe7f42951a853e2cdddfaeedb2a1e366021b2973517b3ca6c6',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'add_to_inventory_event_receiving_success',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AddToInventoryEventReceivingLoadingProperties {
  wmVenueId: string;
  gtin: string | null | undefined;
  catalogProductId: string;
  purchaseOrderPublicId: string | null | undefined;
}
/**
 * add_to_inventory_event_receiving_loading: Adding items popup loading screen
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/_QOZ-OAfj}
 */
export function addToInventoryEventReceivingLoading(
  properties: AddToInventoryEventReceivingLoadingProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.purchaseOrderPublicId !== undefined && properties.purchaseOrderPublicId !== null
    ? eventPropertiesArray.push({
        id: 'xtq8g-Ale',
        name: 'purchase_order_public_id',
        value: properties.purchaseOrderPublicId,
      })
    : eventPropertiesArray.push({ id: 'xtq8g-Ale', name: 'purchase_order_public_id', value: null });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'add_to_inventory' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'receiving_loading' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '_QOZ-OAfj',
        'b511ea369fb923739fd0ae8bdfc705c3d2899f62ed727dd52fc39b02b997e8b7',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'add_to_inventory_event_receiving_loading',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '_QOZ-OAfj',
        'add_to_inventory_event_receiving_loading',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'add_to_inventory_event_receiving_loading',
        eventProperties,
        '_QOZ-OAfj',
        'b511ea369fb923739fd0ae8bdfc705c3d2899f62ed727dd52fc39b02b997e8b7',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'add_to_inventory_event_receiving_loading',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface MultiplePosViewProperties {
  wmVenueId: string;
  purchaseOrderCount: number;
  durationMs: number;
}
/**
 * multiple_pos_view: This view refers to the multiple POS screen that can be reached when the user scan the barcode of an item/outer case or search by item name.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.purchaseOrderCount: Total count of purchase orders displayed on the page.
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KPKbMkERy}
 */
export function multiplePosView(properties: MultiplePosViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'ipY75tiMy',
    name: 'purchase_order_count',
    value: properties.purchaseOrderCount,
  });
  eventPropertiesArray.push({
    id: 'Nu5Md_3-7D',
    name: 'duration_ms',
    value: properties.durationMs,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'multiple_pos' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'KPKbMkERy',
        'dfc119ba8f59e29b44add81e080f038c4c216b756e041c46d57b7d104ae17b18',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('multiple_pos_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'KPKbMkERy',
        'multiple_pos_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'multiple_pos_view',
        eventProperties,
        'KPKbMkERy',
        'dfc119ba8f59e29b44add81e080f038c4c216b756e041c46d57b7d104ae17b18',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('multiple_pos_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MultiplePosInteractionClickProperties {
  wmVenueId: string;
  clickTarget: ClickTargetValueType;
  catalogProductId: string;
  gtin: string | null | undefined;
  purchaseOrderPublicId: string;
}
/**
 * multiple_pos_interaction_click: General click event on the multiple POS screen.

Note: The click_target property should contain the value where the click happened ("multiple_pos").
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.purchaseOrderPublicId: Shows the public id of the purchase order a user interacted with.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RguF4OqNO}
 */
export function multiplePosInteractionClick(properties: MultiplePosInteractionClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({
    id: 'nvdPVEHyGh',
    name: 'click_target',
    value: properties.clickTarget,
  });
  eventPropertiesArray.push({
    id: 'zff8fhnPm',
    name: 'catalog_product_id',
    value: properties.catalogProductId,
  });
  properties.gtin !== undefined && properties.gtin !== null
    ? eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin })
    : eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: null });
  eventPropertiesArray.push({
    id: 'xtq8g-Ale',
    name: 'purchase_order_public_id',
    value: properties.purchaseOrderPublicId,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'multiple_pos' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'RguF4OqNO',
        'c61b878f226c00f0230b8d18cb539343f995e6ac0ccdd598838eaf8e16fbe7b5',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'multiple_pos_interaction_click',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'RguF4OqNO',
        'multiple_pos_interaction_click',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'multiple_pos_interaction_click',
        eventProperties,
        'RguF4OqNO',
        'c61b878f226c00f0230b8d18cb539343f995e6ac0ccdd598838eaf8e16fbe7b5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'multiple_pos_interaction_click',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ReceivingBarcodeScanErrorProperties {
  wmVenueId: string;
  gtin: string;
  catalogProductId: string | null | undefined;
  errorMessage: string;
  barcodeScanType: string | null | undefined;
}
/**
 * receiving_barcode_scan_error: Barcode scan screen errors that might happen if, for example, the gtin scanned is invalid or if the user scans an outer case, but their venue doesn't have the outer case enabled.
 *
 * @param properties the properties associatied with this event
 * @param properties.wmVenueId: Unique id of the Wolt Market venue
 * @param properties.gtin: Global Trade Item Number - sent only for item-related data (no venue, product line etc.)
 * @param properties.catalogProductId: Unique id of the product coming from the product catalog

 * @param properties.errorMessage: Another type of error message returned by the backend (EN)
 * @param properties.barcodeScanType: Type of the barcode scanned (outer case or item).
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/SQqLB7inw}
 */
export function receivingBarcodeScanError(properties: ReceivingBarcodeScanErrorProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8HYK3UKAJ', name: 'wm_venue_id', value: properties.wmVenueId });
  eventPropertiesArray.push({ id: 'MrQsK7Sd8', name: 'gtin', value: properties.gtin });
  properties.catalogProductId !== undefined && properties.catalogProductId !== null
    ? eventPropertiesArray.push({
        id: 'zff8fhnPm',
        name: 'catalog_product_id',
        value: properties.catalogProductId,
      })
    : eventPropertiesArray.push({ id: 'zff8fhnPm', name: 'catalog_product_id', value: null });
  eventPropertiesArray.push({
    id: 'n16SoEsnz8od',
    name: 'error_message',
    value: properties.errorMessage,
  });
  properties.barcodeScanType !== undefined && properties.barcodeScanType !== null
    ? eventPropertiesArray.push({
        id: 'gT9-ATrpR',
        name: 'barcode_scan_type',
        value: properties.barcodeScanType,
      })
    : eventPropertiesArray.push({ id: 'gT9-ATrpR', name: 'barcode_scan_type', value: null });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'error' });
  eventPropertiesArray.push({
    id: 'r5E-SMeZ21',
    name: 'event_name',
    value: 'receiving_barcode_scan_error',
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'barcode_scan' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'SQqLB7inw',
        '9ef748b05d38cc7119d129dc2ee7788e441257dcde5c3e75406043f1eace6655',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('receiving_barcode_scan_error', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'SQqLB7inw',
        'receiving_barcode_scan_error',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'receiving_barcode_scan_error',
        eventProperties,
        'SQqLB7inw',
        '9ef748b05d38cc7119d129dc2ee7788e441257dcde5c3e75406043f1eace6655',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'receiving_barcode_scan_error',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  avoInspectorApiKey,
  View,
  ClickTarget,
  LogType,
  EventName,
  OperationType,
  adjustmentItemReservationModalView,
  adjustmentItemReservationModalInteraction,
  feedbackToastView,
  feedbackToastData,
  feedbackToastInteractionSubmit,
  feedbackToastInteractionRating,
  feedbackToastInteractionClose,
  feedbackToastInteractionComment,
  addToInventoryInteractionBatchClick,
  receivingDataSearchResults,
  receivingDataBarcodeScanResults,
  recevingView,
  receivingView,
  receivingInteractionClickSearchResults,
  receivingComponentsInteraction,
  receivingBarcodeScanView,
  receivingInteractionClickPurchaseOrders,
  receivingInteractionClickRecentlyAddedItems,
  receivingInteractionClickBack,
  receivingInteractionClickUserGuides,
  recentlyAddedItemsView,
  recentlyAddedItemsInteractionClickEdit,
  editReceivingEventView,
  editReceivingEventInteractionClickAddInventory,
  editReceivingEventInteractionClickBatchRemove,
  editReceivingEventSavingError,
  editReceivingEventSavingSuccess,
  addToInventoryView,
  addToInventoryInteractionClick,
  addToInventoryInteractionScreenEventsClick,
  addToInventoryEventReceivingError,
  addToInventoryEventReceivingSuccess,
  addToInventoryEventReceivingLoading,
  multiplePosView,
  multiplePosInteractionClick,
  receivingBarcodeScanError,
};

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["adjustmentItemReservationModalView","adjustmentItemReservationModalInteraction","feedbackToastView","feedbackToastData","feedbackToastInteractionSubmit","feedbackToastInteractionRating","feedbackToastInteractionClose","feedbackToastInteractionComment","addToInventoryInteractionBatchClick","receivingDataSearchResults","receivingDataBarcodeScanResults","recevingView","receivingView","receivingInteractionClickSearchResults","receivingComponentsInteraction","receivingBarcodeScanView","receivingInteractionClickPurchaseOrders","receivingInteractionClickRecentlyAddedItems","receivingInteractionClickBack","receivingInteractionClickUserGuides","recentlyAddedItemsView","recentlyAddedItemsInteractionClickEdit","editReceivingEventView","editReceivingEventInteractionClickAddInventory","editReceivingEventInteractionClickBatchRemove","editReceivingEventSavingError","editReceivingEventSavingSuccess","addToInventoryView","addToInventoryInteractionClick","addToInventoryInteractionScreenEventsClick","addToInventoryEventReceivingError","addToInventoryEventReceivingSuccess","addToInventoryEventReceivingLoading","multiplePosView","multiplePosInteractionClick","receivingBarcodeScanError"]
